if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.countriesThatApplyFeeForHSF = ["US", "CA", "MX", "AU", "NZ"];
			this.shouldValidateHSF = !this.countriesThatApplyFeeForHSF.includes(Shopify.country);  // HSF products should not be considered for installment fee for EUR countries
			this.ajaxifyCartItems();
			this.initializeSubscriptionDetails();
		}

		// #hsfModal / #partnerModal are duplicated in the DOM on the cart page, which renders
		// both snippets/cart-form.liquid (drawer, from theme.liquid) and
		// snippets/cart-form-page.liquid — each with its own copy under the same id.
		// getElementById/document.querySelector therefore always return the page copy, which
		// made every cart-form instance bind its handlers to the same button. Scope by instance.
		hsfModal() {
			return this.querySelector("#hsfModal");
		}

		partnerModal() {
			return this.querySelector("#partnerModal");
		}

		// Full-page overlay from snippets/cart-page-loader.liquid, same one the shared-cart
		// restore and cart-payment-methods.js drive. Only rendered on the cart page, while the
		// drawer runs this flow on every template — so the lookup stays optional.
		setCartPageLoading(isLoading) {
			document.getElementById("page-loader")?.classList.toggle("hidden", !isLoading);
		}

		// The writes that follow a removal — clearing the hsfChildDetails attribute, dropping
		// the installment fee, dropping a handling fee — are decided in three different places
		// but all target /cart/update.js. cart-service.js serialises every mutation, so issuing
		// them separately costs three sequential round-trips. Callers that pass a collector
		// gather them instead and flush once. Passing nothing keeps the old per-write POSTs,
		// which is what the non-HSF cart flows still do.
		createPendingCartWrites() {
			return { updates: {}, attributes: {} };
		}

		pendingCartWritesEmpty(pending) {
			return !pending
				|| (Object.keys(pending.updates).length === 0
					&& Object.keys(pending.attributes).length === 0);
		}

		async flushPendingCartWrites(pending) {
			if (this.pendingCartWritesEmpty(pending)) return;
			// Records that cart-service.js has a freshly seeded cart, so the payment-methods
			// refresh at the end of the flow can read it from cache instead of re-fetching.
			pending.flushed = true;

			const body = {};
			if (Object.keys(pending.updates).length) body.updates = pending.updates;
			if (Object.keys(pending.attributes).length) body.attributes = pending.attributes;

			if (window.JPCartService) {
				await window.JPCartService.update(body);
				return;
			}
			await fetch(KROWN.settings.routes.cart_update_url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
				body: JSON.stringify(body),
			});
		}

		initializeSubscriptionDetails() {
			const variants = document.querySelectorAll('[class*="delivery-billing-details-"]');
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id;
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			variants.forEach((item) => {
				const className = item.className;
				const variantId = className.substring(className.lastIndexOf('-') + 1);
				console.log('Extracted ID:', variantId);
				if (variantId) {
					fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
					})
					.then((response) => response.json()).then((sellingPlanInfo) => {
						const { sellingPlan: { billingPolicy, deliveryPolicy, originalIntervalCount, sellingPlanType } = {}, error } = sellingPlanInfo;
						const isInstallment = sellingPlanType === "installment";
						if (error) {
							throw new Error("Error fetching selling plan info");
						}
						const deliveryInterval = deliveryPolicy.interval;
						const deliveryIntervalCount = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
						const billingInterval = billingPolicy.interval;
						const billingIntervalCount = billingPolicy.intervalCount;
						const spanElementCart = document.querySelector(`.delivery-billing-details-${variantId}`);
						const localizedCartSubscriptionDetailsString = KROWN.settings.locales.delivery_billing_details;
						const updatedCartString = localizedCartSubscriptionDetailsString
							.replace('{{ deliveryInterval }}', mappedIntervalToLocale[deliveryInterval.toLowerCase()])
							.replace('{{ deliveryIntervalCount }}', deliveryIntervalCount)
							.replace('{{ billingInterval }}', mappedIntervalToLocale[billingInterval.toLowerCase()])
							.replace('{{ billingIntervalCount }}', billingIntervalCount);
						if (spanElementCart) {
							spanElementCart.innerHTML = updatedCartString;
						}
					}).catch((e) => {
						console.log(e);
					});
				}
			});
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			let initialproductQuantity = 0;
			let childProduct;
			let parentProduct;
			

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if (remove) {
					remove.dataset.href = remove.getAttribute("href");
					remove.setAttribute("href", "");
					remove.addEventListener("click", (e) => {
					  e.preventDefault();
					  let showHSFModal = remove.getAttribute("data-showhsfModal");
					  let showPartnerModal = remove.getAttribute("data-showpartnerModal");
					  childProduct = remove.getAttribute("data-childproductinfo");
					  parentProduct = remove.getAttribute("data-parentproductinfo");
					  if (showHSFModal == "true") {
						  // Scope to this cart-form: the cart page renders both cart-form.liquid
						  // (drawer) and cart-form-page.liquid, so #hsfModal is not unique and a
						  // document-wide lookup always resolves to the page copy.
						  this.hsfModal()?.show();
					  } else if (showPartnerModal == "true") {
						  // Store partner fee data for modal handler
						  this.partnerFeeVariantId = remove.getAttribute("data-partner-fee-variant-id");
						  this.welcomePackVariantIds = remove.getAttribute("data-welcome-pack-variant-ids");
						  this.starterBundleVariantIds = remove.getAttribute("data-starter-bundle-variant-ids");
						  this.partnerWelcomePackInCart = remove.getAttribute("data-partner-welcome-pack-in-cart") === "true";
						  this.partnerStarterBundlesInCart = remove.getAttribute("data-partner-starter-bundles-in-cart") === "true";
						  this.partnerFeeItem = item;
						  
						  // Build dynamic modal message using translations
						  let modalMessage = KROWN?.settings?.locales?.partner_application_form?.modal_remove_fee || "Are you sure you want to remove the partner application fee?";
						  if (this.partnerWelcomePackInCart && this.partnerStarterBundlesInCart) {
							modalMessage += " " + (KROWN?.settings?.locales?.partner_application_form?.modal_both_removed || "Your Welcome Pack(s) and Starter Bundle product(s) will also be removed!");
						  } else if (this.partnerWelcomePackInCart) {
							modalMessage += " " + (KROWN?.settings?.locales?.partner_application_form?.modal_welcome_pack_removed || "Your Welcome Pack(s) will also be removed!");
						  } else if (this.partnerStarterBundlesInCart) {
							modalMessage += " " + (KROWN?.settings?.locales?.partner_application_form?.modal_starter_bundles_removed || "Your Starter Bundle product(s) will also be removed!");
						  }
						  
						  const partnerModal = this.partnerModal();
						  const partnerMessage = partnerModal?.querySelector("#partner-modal-message");
						  if (partnerMessage) partnerMessage.textContent = modalMessage;
						  partnerModal?.show();
					  } else {
						this.updateCartQty(item, 0)
					  }
					});
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('click', (e)=>{
						e.target.select();
						initialproductQuantity = e.target.value;
					})

					qty.addEventListener('input', debounce( async (e) =>{
						e.preventDefault();
						e.target.blur();
						const prekitAvailable = await e.target.closest("cart-product-quantity").checkProductInventoryPrekit();
						if (prekitAvailable) {
							this.updateCartQty(item, parseInt(qty.value));
						} else {
							e.target.value = initialproductQuantity;
						}	
					}, 500)
					);
				}

			});
			setTimeout(()=>{
				updateNoteObj();
			}, 100);
			
			this.hsfModal()?.querySelector(".remove")?.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();

				// Close before the mutation, not after it: the pipeline below runs several
				// sequential round-trips (cart/update, HSF attribute writes, section fetch,
				// payment refresh) and the dialog used to sit on screen for all of them.
				this.hsfModal()?.hide();

				let updates = {};

				document.querySelectorAll("[data-js-cart-item]").forEach((item) => {
				  if (childProduct == item.id) {
					let childAssociatedParent = item.querySelector('.remove').dataset.parentproductinfo;
					if (childAssociatedParent == parentProduct) {
					  updates["" + item.dataset.id] = 0; 
					}
				  }
				  if (parentProduct == item.id) {
					let parentAssociatedChild = item.querySelector('.remove').dataset.childproductinfo;
					if (parentAssociatedChild == childProduct) {
					  updates["" +item.dataset.id] = 0; 
					}
				  }
				});
				this.removeHSFLineItems(updates)
			});

			// Partner Fee Removal Handler
			const partnerModalConfirmBtn = this.partnerModal()?.querySelector(".partner-remove-confirm");
			if (partnerModalConfirmBtn) {
				partnerModalConfirmBtn.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();

					// Close up front, same reasoning as the HSF confirm above.
					this.partnerModal()?.hide();

					let updates = {};
					
					// Get cart data to find items by variant ID
					(window.JPCartService ? window.JPCartService.getCart({ force: true }) : fetch('/cart.js').then(response => response.json()))
						.then(cartData => {
							// Add partner fee to updates
							if (this.partnerFeeItem && this.partnerFeeItem.dataset.id) {
								updates[this.partnerFeeItem.dataset.id] = 0;
							}
							
							// Get partner fee variant ID for property verification
							const partnerFeeVariantId = this.partnerFeeVariantId;
							
							// Find and add welcome packs if exist AND have _partner_fee_bundle property
							if (this.welcomePackVariantIds && this.partnerWelcomePackInCart && partnerFeeVariantId) {
								const welcomePackIds = this.welcomePackVariantIds.split(',').map(id => id.trim());
								cartData.items.forEach(cartItem => {
									if (welcomePackIds.includes(cartItem.variant_id.toString())) {
										// Verify the item has _partner_fee_bundle property linking to this partner fee
										if (cartItem.properties && 
											cartItem.properties._partner_fee_bundle && 
											cartItem.properties._partner_fee_bundle.toString() === partnerFeeVariantId.toString()) {
											updates[cartItem.key] = 0;
										}
									}
								});
							}
							
							// Find and add starter bundle products if exist AND have _partner_fee_bundle property
							if (this.starterBundleVariantIds && this.partnerStarterBundlesInCart && partnerFeeVariantId) {
								const bundleVariantIds = this.starterBundleVariantIds.split(',').map(id => id.trim());
								cartData.items.forEach(cartItem => {
									if (bundleVariantIds.includes(cartItem.variant_id.toString())) {
										// Verify the item has _partner_fee_bundle property linking to this partner fee
										if (cartItem.properties && 
											cartItem.properties._partner_fee_bundle && 
											cartItem.properties._partner_fee_bundle.toString() === partnerFeeVariantId.toString()) {
											updates[cartItem.key] = 0;
										}
									}
								});
							}
							
							// Remove all related items
							this.removePartnerRelatedItems(updates);
						})
						.catch(error => {
							console.error('Error fetching cart data:', error);
						});
				});
			}

		}

		isHsfTruthy(value) {
			return value === true || String(value || '').trim().toLowerCase() === 'true';
		}

		parseHsfVariantIdList(raw) {
			return String(raw || '')
				.split(',')
				.map((id) => id.trim())
				.filter(Boolean);
		}

		isInstallmentFeeCartLine(item, feeVariantId, feeProductId) {
			const variantId = item.variant_id ?? item.id;
			return variantId === feeVariantId || item.id === feeVariantId || item.product_id === feeProductId;
		}

		/**
		 * After stripping HSF keys, align line properties with PDP shape so a later
		 * add of the same variant merges (Shopify matches on full properties).
		 * Mirrors shared-cart normal-line reconstruction for selling plan / ots.
		 */
		normalizeDemotedHsfAdultProperties(item, isManualPayment) {
			const nextProperties = { ...(item.properties || {}) };
			delete nextProperties._hsf;
			delete nextProperties._childProductIds;

			const sellingPlanName =
				String(nextProperties._selling_plan_name || '').trim() ||
				String(item.selling_plan_allocation?.selling_plan?.name || '').trim();

			const existingSellingPlan = String(nextProperties._sellingplan || '').trim();
			if (isManualPayment && existingSellingPlan) {
				nextProperties._sellingplan = existingSellingPlan;
			} else {
				nextProperties._sellingplan = '';
			}
			nextProperties._selling_plan_name = sellingPlanName;

			nextProperties._ots_installment =
				String(nextProperties._ots_installment || '').trim() === 'true' ? 'true' : 'false';

			return nextProperties;
		}

		/**
		 * When HSF child lines are gone, demote orphaned HSF adults (clear _hsf /
		 * _childProductIds), clear hsfChildDetails, and add installment fee if a
		 * demoted adult is now an eligible PPM line. Runs only after cart qty/remove.
		 * Orphan rule: an HSF adult is demoted when no remaining child line lists that
		 * adult's variant id in _adultProductIds (pair-aware, not child-variant presence).
		 * Writes are serial: demote adults → fee add → clear hsfChildDetails.
		 * Pass cart JSON from the preceding change/update to avoid an extra /cart.js GET.
		 * Returns a cart-like object for downstream side-effects (no post-HSF /cart fetch).
		 */
		async checkAndRemoveHsfAttributes(cartData, pending) {
			if (!cartData || !Array.isArray(cartData.items)) {
				cartData = await (window.JPCartService
					? window.JPCartService.getCart({ force: true })
					: fetch(KROWN.settings.routes.cart_url, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
					}).then((res) => res.json()));
			}

			const items = cartData.items || [];

			// Adult variant ids still claimed by at least one HSF child line.
			const adultsWithPresentChild = new Set();
			let hasPresentHsfChild = false;
			for (const item of items) {
				const props = item.properties || {};
				if (!this.isHsfTruthy(props._hsf)) continue;
				const linkedAdultIds = this.parseHsfVariantIdList(props._adultProductIds);
				if (!linkedAdultIds.length) continue;
				hasPresentHsfChild = true;
				for (const adultId of linkedAdultIds) {
					adultsWithPresentChild.add(adultId);
				}
			}

			const orphanedAdults = [];
			for (const item of items) {
				const props = item.properties || {};
				if (!this.isHsfTruthy(props._hsf)) continue;
				// Adults carry _childProductIds; children carry _adultProductIds.
				if (!this.parseHsfVariantIdList(props._childProductIds).length) continue;

				const adultVariantId = String(item.variant_id ?? item.id);
				if (adultsWithPresentChild.has(adultVariantId)) continue;

				orphanedAdults.push(item);
			}

			const shouldClearHsfChildDetails =
				!!cartData.attributes?.hsfChildDetails && !hasPresentHsfChild;

			if (!orphanedAdults.length && !shouldClearHsfChildDetails) {
				return cartData;
			}

			const isManualPayment = typeof resolveInstallmentFeeManualPayment === 'function'
				? resolveInstallmentFeeManualPayment(cartData)
				: false;

			const demotedByKey = new Map();
			let demotedInstallmentAdult = false;
			const changeHeaders = {
				"Content-Type": "application/json",
				Accept: "application/javascript",
			};

			for (const item of orphanedAdults) {
				const nextProperties = this.normalizeDemotedHsfAdultProperties(item, isManualPayment);
				demotedByKey.set(item.key, nextProperties);

				if (String(nextProperties._subscriptionType || '').trim().toLowerCase() === 'installment') {
					demotedInstallmentAdult = true;
				}

				if (window.JPCartService) {
					await window.JPCartService.change({
						id: item.key,
						quantity: item.quantity,
						properties: nextProperties
					});
				} else {
					await fetch(KROWN.settings.routes.cart_change_url, {
						method: "POST",
						headers: changeHeaders,
						body: JSON.stringify({
							id: item.key,
							quantity: item.quantity,
							properties: nextProperties
						}),
					});
				}
			}

			const workingItems = items.map((item) => {
				const demotedProps = demotedByKey.get(item.key);
				return demotedProps ? { ...item, properties: demotedProps } : item;
			});

			const feeVariantId = Number(localStorage.getItem('installmentFeeVariantId'));
			const feeProductId = Number(localStorage.getItem('installmentFeeProductId'));
			const hasFeeConfig = !!localStorage.getItem('installmentFeeVariantId')
				&& !!localStorage.getItem('installmentFeeVariantSellingPlanId');
			const hasFee = workingItems.some((item) => this.isInstallmentFeeCartLine(item, feeVariantId, feeProductId));
			const eligibleInstallment = workingItems.filter((item) => {
				if (this.isInstallmentFeeCartLine(item, feeVariantId, feeProductId)) return false;
				if (item.properties?._subscriptionType !== 'installment') return false;
				if (this.shouldValidateHSF && this.isHsfTruthy(item.properties?._hsf)) return false;
				return true;
			});

			const shouldAddFee = demotedInstallmentAdult
				&& hasFeeConfig
				&& !hasFee
				&& eligibleInstallment.length > 0
				&& typeof postInstallmentFeeItem === 'function';

			let feeAdded = false;
			if (shouldAddFee) {
				feeAdded = !!(await postInstallmentFeeItem(isManualPayment));
			}

			// Clear HSF attribute after line/fee writes so a concurrent cart/add
			// cannot overwrite hsfChildDetails with a stale cart snapshot.
			if (shouldClearHsfChildDetails) {
				if (pending) {
					pending.attributes.hsfChildDetails = null;
				} else if (window.JPCartService) {
					await window.JPCartService.update({ attributes: { hsfChildDetails: null } });
				} else {
					await fetch(KROWN.settings.routes.cart_update_url, {
						method: "POST",
						headers: changeHeaders,
						body: JSON.stringify({
							attributes: { hsfChildDetails: null }
						}),
					});
				}
			}

			let nextItems = workingItems;
			if (feeAdded && typeof buildInstallmentFeeItem === 'function') {
				const feeLine = buildInstallmentFeeItem(isManualPayment);
				if (feeLine) {
					const feeId = Number(feeLine.id);
					nextItems = [
						...workingItems,
						{
							id: feeId,
							variant_id: feeId,
							product_id: feeProductId || feeId,
							quantity: 1,
							properties: feeLine.properties || {},
							key: String(feeId)
						}
					];
				}
			}

			const nextAttributes = { ...(cartData.attributes || {}) };
			if (shouldClearHsfChildDetails) {
				nextAttributes.hsfChildDetails = null;
			}

			return {
				...cartData,
				items: nextItems,
				attributes: nextAttributes
			};
		}

		// window.removeInstallmentFee POSTs purely off the localStorage fee id, so it fires even
		// when no fee line is in the cart. With a collector we queue the removal instead, and
		// only when the line is actually there.
		async removeInstallmentFeeLine(cartItems, pending) {
			const feeVariantId = Number(localStorage.getItem('installmentFeeVariantId'));
			if (!feeVariantId) return;

			const feeProductId = Number(localStorage.getItem('installmentFeeProductId'));
			const feeLine = cartItems.find((item) =>
				this.isInstallmentFeeCartLine(item, feeVariantId, feeProductId)
			);
			if (!feeLine) return;

			if (pending) {
				pending.updates['' + feeVariantId] = 0;
				return;
			}
			await removeInstallmentFee();
		}

		async reconcileCartAfterMutation(cartData, pending) {
			let cart = cartData;
			if (!cart || !Array.isArray(cart.items)) {
				cart = await (window.JPCartService
					? window.JPCartService.getCart({ force: true })
					: fetch(KROWN.settings.routes.cart_url, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
					}).then((res) => res.json()));
			}

			const cartItems = cart.items || [];

			const installmentProductsThatApplyFee = cartItems.filter((item) =>
				item.id !== Number(localStorage.getItem('installmentFeeProductId')) &&
				item.properties?._subscriptionType === 'installment' &&
				(this.shouldValidateHSF ? !item.properties?._hsf : true)
			);
			if (installmentProductsThatApplyFee.length === 0) {
				await this.removeInstallmentFeeLine(cartItems, pending);
			}

			await this.checkAndRemoveHandlingFee(cartItems, pending);

			// One request for the installment fee, the handling fee and the HSF attribute
			// clear, instead of one each. Must land before the section render below.
			const removedKeys = new Set(
				pending ? Object.keys(pending.updates).filter((key) => pending.updates[key] === 0) : []
			);
			await this.flushPendingCartWrites(pending);

			const remainingItems = cartItems.filter((item) =>
				!removedKeys.has(String(item.key)) && !removedKeys.has(String(item.id))
			);
			$(".countries_list_modal-content")
				.attr('data-cart-empty', remainingItems.length === 0 ? "true" : "false");

			return fetch('?section_id=helper-cart');
		}

		/**
		 * While cart remove/HSF reconcile is in flight: mini cart shows
		 * .cart-buttons-loader (blocks View cart + Checkout); cart page shows
		 * in-button loader and keeps checkout disabled.
		 * On clear: never force-show mini button row — refreshCartPaymentMethods owns that.
		 */
		setCartCheckoutLoading(isLoading) {
			const miniLoader = document.querySelector('.cart-buttons-loader');
			const miniButtons = document.querySelector('.flex-buttons.mini-cart-buttons-container');

			if (isLoading) {
				if (miniLoader) miniLoader.style.display = '';
				if (miniButtons) miniButtons.style.display = 'none';
			} else if (miniLoader) {
				miniLoader.style.display = 'none';
			}

			const setCheckoutButtonLoading = (button, loader, text) => {
				if (!button) return;
				if (isLoading) {
					if (loader) loader.classList.remove('display-none');
					if (text) text.classList.add('display-none');
					button.disabled = true;
				} else {
					if (loader) loader.classList.add('display-none');
					if (text) text.classList.remove('display-none');
					button.disabled = false;
				}
			};

			setCheckoutButtonLoading(
				document.getElementById('CheckOut'),
				document.getElementById('guest-button-loader'),
				document.querySelector('.guest-user-button-text')
			);
			setCheckoutButtonLoading(
				document.getElementById('custom-checkout-button'),
				document.getElementById('custom-button-loader'),
				document.getElementById('custom-button-text')
			);
		}

		async refreshCartPaymentMethodsAfterMutation(options) {
			if (typeof window.refreshCartPaymentMethods !== 'function') {
				return;
			}
			await window.refreshCartPaymentMethods(options);
		}

		async checkAndRemoveHandlingFee(cartItems, pending) {
			// Get all handling fee items
			const handlingFeeItems = cartItems.filter(item => 
				item.properties && item.properties._handling_fee
			);

			if (handlingFeeItems.length === 0) return;

			// Check each handling fee item
			for (const handlingFeeItem of handlingFeeItems) {
				const adultProductIds = handlingFeeItem.properties._adultProductIds?.split(',') || [];
				const childProductIds = handlingFeeItem.properties._childProductIds?.split(',') || [];
				
				// Check if referenced adult products still exist in cart
				const adultProductsInCart = adultProductIds.filter(id => 
					cartItems.some(item => item.id.toString() === id.toString())
				);
				
				// Check if referenced child products still exist in cart
				const childProductsInCart = childProductIds.filter(id => 
					cartItems.some(item => item.id.toString() === id.toString())
				);
				
				// Remove handling fee if either adult or child products are completely removed
				if (adultProductsInCart.length === 0 || childProductsInCart.length === 0) {
					const updates = {};
					updates[handlingFeeItem.key] = 0;

					if (pending) {
						pending.updates[handlingFeeItem.key] = 0;
					} else if (window.JPCartService) {
						await window.JPCartService.enqueuePost(KROWN.settings.routes.cart_update_url, JSON.stringify({ updates }), { "Content-Type": "application/json", Accept: "application/javascript" });
					} else {
						await fetch(KROWN.settings.routes.cart_update_url, {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
								Accept: "application/javascript",
							},
							body: JSON.stringify({ updates }),
						});
					}
				}
			}
		}

		checkAndRemovePartnerAttributes(cartObject) {
			if(cartObject.items_removed && cartObject.items_removed.length > 0 && cartObject.attributes._partnerFeeProduct){
				cartObject.items_removed.forEach(item => {
					if(item.variant_id == Number(cartObject.attributes._partnerFeeProduct)){
						return this.removePartnerFeeAttributes();
					}
				})
			}
		}

		removePartnerFeeAttributes() {
			const body = {
				attributes: {
					_partnerFeeProduct: null
				}
			}
			return window.JPCartService
				? window.JPCartService.enqueuePost(KROWN.settings.routes.cart_update_url, JSON.stringify(body), { "Content-Type": "application/json", Accept: "application/javascript" })
				: fetch(KROWN.settings.routes.cart_update_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/javascript",
					},
					body: JSON.stringify(body),
				})
		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			this.setCartCheckoutLoading(true);
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			return (window.JPCartService
				? window.JPCartService.enqueuePost(KROWN.settings.routes.cart_change_url, body, { 'Content-Type': 'application/json', 'Accept': 'application/javascript' })
				: fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				}))
				.then(response => response.json())
				.then(async (response) => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						return null;
					}
					this.checkAndRemovePartnerAttributes(response);
					return this.checkAndRemoveHsfAttributes(response);
				}).then(async (cartData) => {
					return this.reconcileCartAfterMutation(cartData);
				})
				.then(response => response.text())
				.then(async (response) => {
					const sectionInnerHTML = new DOMParser().parseFromString(response, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					// Keep mini-cart loader until payment methods decide button visibility.
					this.setCartCheckoutLoading(true);
							
					const event = new Event('cart-updated', { bubbles: true });
					this.dispatchEvent(event);

					await this.refreshCartPaymentMethodsAfterMutation();
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.setCartCheckoutLoading(false);
					this.form.classList.remove('processing');
				});
		}

		removeHSFLineItems(updates) {
			let alert = null;
			const pendingWrites = this.createPendingCartWrites();

			this.form.classList.add("processing");
			this.setCartCheckoutLoading(true);
			this.setCartPageLoading(true);
			if (this.querySelector(".alert")) {
			  	this.querySelector(".alert").remove();
			}    
			
			const body = JSON.stringify({updates});
	  
			return (window.JPCartService
				? window.JPCartService.enqueuePost(KROWN.settings.routes.cart_update_url, body, { "Content-Type": "application/json", Accept: "application/javascript" })
				: fetch(KROWN.settings.routes.cart_update_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/javascript",
					},
					body,
				}))
			.then((response) => response.json())
			.then(async (response) => {
				if (response.status == 422) {
					// wrong stock logic alert
					alert = document.createElement("span");
					alert.classList.add("alert", "alert--error");
					if (typeof response.description === "string") {
					alert.innerHTML = response.description;
					} else {
					alert.innerHTML = response.message;
					}
					return null;
				}
				this.checkAndRemovePartnerAttributes(response);
				return this.checkAndRemoveHsfAttributes(response, pendingWrites);
			}).then(async (cartData) => {
				return this.reconcileCartAfterMutation(cartData, pendingWrites);
			})
			.then((response) => response.text())
			.then(async (text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(
					text,
					"text/html"
				);
				const cartFormInnerHTML =
					sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
				const cartSubtotalInnerHTML =
					sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;
		
				const cartItems = document.getElementById("AjaxCartForm");
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
		
				document
					.querySelectorAll("[data-header-cart-count]")
					.forEach((elm) => {
					elm.textContent =
						cartItems.querySelector("[data-cart-count]").textContent;
					});
				document
					.querySelectorAll("[data-header-cart-total")
					.forEach((elm) => {
					elm.textContent =
						cartItems.querySelector("[data-cart-total]").textContent;
					});
		
				if (alert !== null) {
					this.form.prepend(alert);
				}
		
				document.getElementById("AjaxCartSubtotal").innerHTML =
					cartSubtotalInnerHTML;
				this.setCartCheckoutLoading(true);
		
				const event = new Event("cart-updated", { bubbles: true });
				this.dispatchEvent(event);

				// The batched flush already seeded cart-service's cache, so skip the forced
				// re-read; without a flush the cache is stale and must be refetched.
				await this.refreshCartPaymentMethodsAfterMutation({ force: !pendingWrites.flushed });
			})
			.catch((e) => {
				console.log(e);
				let alert = document.createElement("span");
				alert.classList.add("alert", "alert--error");
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			})
			.finally(() => {
				this.setCartCheckoutLoading(false);
				this.setCartPageLoading(false);
				this.form.classList.remove("processing");
				// Already hidden on confirm; this only clears the scroll-lock body class
				// if the dialog was still open (e.g. an early failure path).
				this.hsfModal()?.hide();
			});
		}

		removePartnerRelatedItems(updates) {
			let alert = null;
	  
			this.form.classList.add("processing");
			this.setCartCheckoutLoading(true);
			if (this.querySelector(".alert")) {
			  	this.querySelector(".alert").remove();
			}    
			
			const body = JSON.stringify({updates});
	  
			return (window.JPCartService
				? window.JPCartService.enqueuePost(KROWN.settings.routes.cart_update_url, body, { "Content-Type": "application/json", Accept: "application/javascript" })
				: fetch(KROWN.settings.routes.cart_update_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/javascript",
					},
					body,
				}))
			.then((response) => response.json())
			.then(async (response) => {
				if (response.status == 422) {
					// wrong stock logic alert
					alert = document.createElement("span");
					alert.classList.add("alert", "alert--error");
					if (typeof response.description === "string") {
					alert.innerHTML = response.description;
					} else {
					alert.innerHTML = response.message;
					}
					return null;
				}
				// Directly remove partner fee attribute since we know partner fee is being removed
				await this.removePartnerFeeAttributes();
				return this.checkAndRemoveHsfAttributes(response);
			}).then(async (cartData) => {
				return this.reconcileCartAfterMutation(cartData);
			})
			.then((response) => response.text())
			.then(async (text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				if ( alert !== null ) {
					this.form.prepend(alert);
				} 

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				this.setCartCheckoutLoading(true);
						
				if (document.querySelector('cart-recommendations')) {
					document.querySelector('cart-recommendations').innerHTML = '';
					document.querySelector('cart-recommendations').generateRecommendations();
				}

				const event = new Event("cart-updated", { bubbles: true });
				this.dispatchEvent(event);

				await this.refreshCartPaymentMethodsAfterMutation();
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				this.setCartCheckoutLoading(false);
				this.form.classList.remove("processing");
				this.partnerModal()?.hide();
			});
		}

	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', async (e) => {
				const prekitResponse = await this.checkProductInventoryPrekit();
				if (prekitResponse) {
					this.changeCartInput(this);
				} else {
					const inputElement = e.target.closest("cart-product-quantity").querySelector("input");
					inputElement.value = inputElement.value - 1;
				}
			})
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}

		// function to check for prekit in mini-cart when adding product quantity
		async checkProductInventoryPrekit() {
			const miniCartComponent = this.closest(".cart-item__content");
			const cartComponent = this.closest(".cart-item__product-info");
			const currentComponent = miniCartComponent ?? cartComponent; // set current component based on cart or cart-flyout

			const url = `${currentComponent.querySelector("a").href}&view=inventory-check`;
			const userInputQuantity = currentComponent.querySelector("input").value;
			let cartForm = this.closest("#AjaxCartForm").form;
			const productName = currentComponent.querySelector(".cart-item__title").innerText;
			const productVariant = currentComponent.querySelector(".cart-item__variant")?.innerText.split(": ")[1];
			let canAddQuantity = true;
			let alertWarning = null;

			if ( cartForm.querySelector('.alert--error') ) {
				cartForm.querySelectorAll('.alert--error').forEach(alert => alert.remove());
			}

			try {

				const response = await fetch(url);

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const responseData = await response.text(); // Assuming plain text
				const prekit_data = responseData.trim().split("|"); // disabling/enabling add to cart button - not required here
				const prekitObj = JSON.parse(prekit_data[1]); // object with inventory amount and quantity of variants in prekit

				if (prekitObj.length > 0) {
					const minqty = prekitObj[0].inventory / prekitObj[0].quantity;

					for (let prekit of prekitObj) {
						const quantity = prekit["quantity"];
						const inventory = prekit["inventory"];
						if (minqty > inventory / quantity) {
							minqty = inventory / quantity;
						}
						if (quantity * userInputQuantity > parseInt(inventory)) {
							canAddQuantity = false;
							break;
						}
					}

					if (!canAddQuantity) {
						alertWarning = document.createElement('span');
						alertWarning.classList.add('alert', 'alert--error');
						const alertText = KROWN.settings.cart_prekit_error.replace("{{ product }}",`${productName} - ${productVariant}`);
						alertWarning.innerHTML = alertText;
						cartForm.prepend(alertWarning);
					}
				} else {
					canAddQuantity = true; // no prekit information, hence OOTB process for adding quantity
				}
				return canAddQuantity;
			}
			catch(error) {
				console.error("Error fetching stock data:", error); // Handle error gracefully, e.g., display an error message to the user
			};
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		return new Promise((resolve, reject) => {
			fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => {
	
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
	
				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
	
				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				})
				
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
					document.querySelector('[data-js-site-cart-sidebar]').show();
				}
	
				if ( document.querySelector('cart-recommendations') ) {
					document.querySelector('cart-recommendations').innerHTML = '';
					document.querySelector('cart-recommendations').generateRecommendations();
				}
	
				resolve()
			})
		})

	}

}
if (!window.refreshCartPaymentChange) {
  window.refreshCartPaymentChange = async () => {
    try {
      // Fetch the updated cart section
      const response = await fetch("?section_id=helper-cart");
      const text = await response.text();

      const sectionInnerHTML = new DOMParser().parseFromString(
        text,
        "text/html"
      );

      // Get updated cart form and subtotal HTML
      const cartFormInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
      const cartSubtotalInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

      // Update cart form
      const cartItems = document.getElementById("AjaxCartForm");
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      // Update cart count and total in header
      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent =
          cartItems.querySelector("[data-cart-count]").textContent;
      });

      document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
        elm.textContent =
          cartItems.querySelector("[data-cart-total]").textContent;
      });

      // Update subtotal
      document.getElementById("AjaxCartSubtotal").innerHTML =
        cartSubtotalInnerHTML;

      // Update cart recommendations
      const recommendations = document.querySelector("cart-recommendations");
      if (recommendations) {
        recommendations.innerHTML = "";
        recommendations.generateRecommendations();
      }

      // Refresh payment methods after 100ms delay
      if (typeof window.refreshCartPaymentMethods === "function") {
        await new Promise((resolve) => {
          setTimeout(async () => {
            await window.refreshCartPaymentMethods();
            resolve();
          }, 100);
        });
      }
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  };
}

function updateNoteObj() {
	// let noteElement = document.getElementById("cartSpecialInstructions");
	// Commenting custom note object as installment details will be moved to order metafields
	// if (noteElement) {
	// 	let noteObjStr = noteElement.value;
	// 	let isLeadPool = document.getElementById("isLeadPool");
	// 	try {
	// 		let NoteObj = JSON.parse(noteObjStr);
	// 		NoteObj.isLeadPool = isLeadPool && isLeadPool.value === "true" ? true : false;
	// 		noteElement.value = JSON.stringify(NoteObj);
	// 	} catch(e) {
	// 		console.log("Error" + e);
	// 	}
	// }
	// update hsf child form details in cart attribute
}

document.addEventListener("DOMContentLoaded", function () {
  updateNoteObj();
});
